import { UserOutlined } from "@ant-design/icons";
import { Alert, Card, Space, Typography } from "antd";
import { LogoutButton } from "../../../authentication/components/ui/LogoutButton";
import { useAuth } from "../../hooks/useAuth";

const { Text, Title } = Typography;

export const AuthStatus = () => {
	const { user, isAuthenticated, isLoading } = useAuth();

	if (isLoading) {
		return (
			<Card>
				<Text>Loading authentication status...</Text>
			</Card>
		);
	}

	if (!isAuthenticated || !user) {
		return (
			<Card>
				<Alert
					message="Not Authenticated"
					description="Please log in to access this application."
					type="warning"
					showIcon
				/>
			</Card>
		);
	}

	return (
		<Card title="Authentication Status">
			<Space direction="vertical" style={{ width: "100%" }}>
				<Title level={4}>
					<UserOutlined /> Welcome, {user.username}!
				</Title>
				<Text>Manager ID: {user.managerId}</Text>
				<Text type="success">Status: Authenticated ✓</Text>
				<LogoutButton type="primary">ログアウト</LogoutButton>
			</Space>
		</Card>
	);
};
